import React from "react";
import EditAutomaticReleaseCreationPage from "./EditAutomaticReleaseCreationPage";
interface EditBuiltInFeedTriggerPageProps {
    spaceId: string;
    projectSlug: string;
}
export function EditBuiltInFeedTriggerPage({ spaceId, projectSlug }: EditBuiltInFeedTriggerPageProps) {
    return <EditAutomaticReleaseCreationPage create={false} spaceId={spaceId} projectSlug={projectSlug}/>;
}
